import { EditButton, List, useDataGrid } from '@refinedev/mui';
import React from 'react';
import { genDocumentSlug } from 'shiver-core/lib';
import { DataGrid, type GridColDef } from '../../../components/DataGrid.tsx';
import { useColumnVisibilityModel } from '../../../hooks/columnVisibilityModel.ts';
import { Series } from '../../../types/index.ts';

export const SeriesList = () => {
  const { dataGridProps, filters, setFilters } = useDataGrid<Series>({
    resource: 'contents/series',
    queryOptions: {
      select({ data, total }) {
        return {
          data: data.map((row) => Series.parse(row)),
          total,
        };
      },
    },
  });

  const columns = React.useMemo<Array<GridColDef<Series>>>(() => {
    const columns: Array<GridColDef<Series>> = [
      {
        type: 'actions',
        field: 'actions',
        headerName: '',
        renderCell({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
            </>
          );
        },
      },
      {
        field: 'slug',
        headerName: 'slug',
        display: 'flex',
        minWidth: 200,
        valueGetter(_, row) {
          return genDocumentSlug(row.id);
        },
      },
      {
        field: 'name',
        headerName: '名称',
        flex: 3,
      },
      {
        type: 'dateTime',
        field: 'createdAt',
        headerName: '作成日時',
        display: 'flex',
        minWidth: 150,
        valueFormatter(_, { createdAt }) {
          if (!createdAt) return '-';
          return createdAt.toLocaleString('ja-JP').replace(/:\d{2}$/, '');
        },
      },
      {
        field: 'createdBy',
        headerName: '作成者',
        display: 'flex',
        minWidth: 150,
        valueGetter(_, row) {
          return row.createdBy ?? '-';
        },
      },
      {
        type: 'dateTime',
        field: 'modifiedAt',
        headerName: '変更日時',
        display: 'flex',
        minWidth: 150,
        valueFormatter(_, { modifiedAt }) {
          if (!modifiedAt) return '-';
          return modifiedAt.toLocaleString('ja-JP').replace(/:\d{2}$/, '');
        },
      },
      {
        field: 'modifiedBy',
        headerName: '変更者',
        display: 'flex',
        minWidth: 150,
        valueGetter(_, row) {
          return row.modifiedBy ?? '-';
        },
      },
    ];

    return columns;
  }, []);

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useColumnVisibilityModel('contents/series');

  return (
    <List>
      <DataGrid
        {...dataGridProps}
        columns={columns}
        filters={filters}
        setFilters={setFilters}
        filterDebounceMs={800}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={setColumnVisibilityModel}
      />
    </List>
  );
};
